var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RenderBlocks',{attrs:{"blocks":_vm.block.innerBlocks,"parentBlock":_vm.block}})
}
var staticRenderFns = []

export { render, staticRenderFns }